import {
  EDUCATION_LEVEL,
  EducationLevel,
} from "@portal/app/_common/types/customerDetail";

const VALID_VALUES = new Set<string>(Object.values(EDUCATION_LEVEL));

/**
 * Validates and normalizes a form answer value to a valid EducationLevel.
 * Trims whitespace, uppercases, and checks against the EDUCATION_LEVEL enum.
 * Returns the typed value if valid, or undefined if not a recognized level.
 */
export function normalizeEducationLevel(
  value: string
): EducationLevel | undefined {
  const normalized = value.trim().toUpperCase();
  if (VALID_VALUES.has(normalized)) {
    return normalized as EducationLevel;
  }
  return undefined;
}
